// Components==============
import React, { createContext, useMemo, useState } from 'react';
// =========================

type GlobalRootModalContextType = {
  rootModal: React.ReactNode;
  setRootModal: React.Dispatch<React.SetStateAction<React.ReactNode>>;
};

export const GlobalRootModalContext = createContext(
  {} as GlobalRootModalContextType
);

export default function GlobalRootModal({
  children,
}: {
  children: React.ReactNode;
}) {
  const [rootModal, setRootModal] = useState<React.ReactNode>(null);

  const value = useMemo(
    () => ({
      rootModal,
      setRootModal,
    }),
    [rootModal]
  );

  return (
    <GlobalRootModalContext.Provider value={value}>
      {children}
    </GlobalRootModalContext.Provider>
  );
}
